import { minorUnitToMajorUnit } from "@repo/system";
import { type KioskDisplayBasketItem } from "~/stores/kiosk-session/hooks/use-kiosk-products/types";

import { toFreedomPayItems } from "./to-freedompay-items";

type BuildFreedomPayRequestArgs = {
  productsBasket: KioskDisplayBasketItem[];
  /** What the customer is charged: products and deposits together. */
  unitTotalPayableInclVat: number;
  unitTotalPriceExclVat: number;
  unitTotalDepositExclVat: number;
};

/**
 * The money half of the FreedomPay purchase request.
 *
 * Freeway rejects the request unless the lines sum to the amount charged and
 * their tax sums to `taxTotal`. That is a property of these three values
 * together, not of any one of them, so they are built in one place where a
 * test can assert it.
 */
export function buildFreedomPayRequest({
  productsBasket,
  unitTotalPayableInclVat,
  unitTotalPriceExclVat,
  unitTotalDepositExclVat
}: BuildFreedomPayRequestArgs) {
  return {
    totalPriceInclVat: minorUnitToMajorUnit(unitTotalPayableInclVat),
    items: toFreedomPayItems(productsBasket),
    // Everything charged less everything net, so a taxed deposit's VAT is
    // carried here exactly as the lines carry it.
    taxTotal: minorUnitToMajorUnit(
      unitTotalPayableInclVat -
        (unitTotalPriceExclVat + unitTotalDepositExclVat)
    )
  };
}
